var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#D6A444","cx":"112.5","cy":"112.5","r":"112.5","key":0}),React.createElement("path",{"d":"M104.390625,173 L104.390625,88.15625 L119.78125,88.15625 L119.78125,173 L104.390625,173 Z M104.390625,72.765625 L104.390625,57.375 L119.78125,57.375 L119.78125,72.765625 L104.390625,72.765625 Z","fill":"#FFF","fillRule":"nonzero","key":1})]));
}

InfoIcon.defaultProps = {"viewBox":"0 0 225 225"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
